@if (isCreatingWidget()) {
  <h2 class="creating-widget-title">{{ 'CREATE_WEB_CHAT_WIDGET.LOADING_DESCRIPTION' | translate }}</h2>
}
@if (isLoading() || isCreatingWidget()) {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else {
  @if (apps()?.length === 0 && isCreateWidgetRouteSet()) {
    <glxy-empty-state [size]="'small'">
      <glxy-empty-state-title>
        {{ 'APPLICATION_SELECTOR.NO_APPS_TITLE' | translate }}
      </glxy-empty-state-title>
      <p>{{ 'APPLICATION_SELECTOR.NO_APPS_BODY' | translate }}</p>
      <glxy-empty-state-actions>
        <button mat-stroked-button (click)="createWidgetClick()">
          {{ 'APPLICATION_SELECTOR.CREATE_WIDGET' | translate }}
        </button>
      </glxy-empty-state-actions>
    </glxy-empty-state>
  } @else {
    <div>{{ 'APPLICATION_SELECTOR.ADD_KNOWLEDGE_TO' | translate }}</div>

    <ai-knowledge-application-list
      [apps]="selectedApps()"
      (removeClicked)="removeApp($event)"
    ></ai-knowledge-application-list>

    <glxy-form-field class="app-select">
      <input
        #appInput
        matInput
        #trigger="matAutocompleteTrigger"
        placeholder="{{ 'APPLICATION_SELECTOR.PLACEHOLDER' | translate }}"
        [formControl]="selectedAppControl"
        autocomplete="off"
        (keydown.enter)="chooseMatch($event)"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addApp($event.option.value)">
        @if (filteredApps().length === 0) {
          <mat-option [disabled]="true">
            <div matLine>{{ 'COMMON.NO_RESULTS' | translate }}</div>
          </mat-option>
        }

        @for (app of filteredApps(); track app) {
          <mat-option [value]="app" class="source-option">
            <div matLine>{{ app.name }}</div>
            <div matLine class="app-type-name">{{ app.appTypeName }}</div>
          </mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
  }
}
